import { render, staticRenderFns } from "./ClientRegistration.vue?vue&type=template&id=2376bb86"
import script from "./ClientRegistration.vue?vue&type=script&lang=js"
export * from "./ClientRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports